import styles from '../../css/base/CampaignInfoDisplay.base.module.css';

interface CampaignInfoSeparatorProps {
  show: boolean;
  variant?: 'default' | 'thin' | 'thick';
}

const CampaignInfoSeparator: React.FC<CampaignInfoSeparatorProps> = ({ show, variant = 'thin' }) => {
  if (!show) return null;
  
  return <span className={`${styles['separator']} ${styles[variant]}`} />;
};

export default CampaignInfoSeparator;
